import { render } from "./BreakfastModal.vue?vue&type=template&id=3e610cc4&ts=true"
import script from "./BreakfastModal.vue?vue&type=script&lang=ts"
export * from "./BreakfastModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__